import React from "react";
import {NavigationHorizontal} from "../../../helpers/MerchantNavigation";

import {NAVIGATION_MERCHANT} from "../../constants";

import AccountDisplay from "../AccountDisplay";
import MerchantLogo from "../MerchantLogo";

export default () => {
  return (
    <div className="merchant-layout__header desktop">
      <MerchantLogo />
      <NavigationHorizontal
        menu={NAVIGATION_MERCHANT}
      />
      <AccountDisplay />
    </div>
  );
}
